(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-head"]) return;
  try {
    
  $('document').ready(function () {
    // スライダー初期化を関数化
    function initializeSliders() {
      if ($('.g-slider').length) {
        $('.g-slider').on('init', function (event, slick) {
          AOS.init();
        });

        $('.g-slider').not('.slick-initialized').slick({
          autoplay: true,
          autoplaySpeed: 0,
          speed: 5000,
          cssEase: 'linear',
          slidesToShow: 7,
          swipe: false,
          arrows: false,
          pauseOnFocus: false,
          pauseOnHover: false,
          responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 4,
              },
            },
          ],
        });
      }
    }

    // DOMの読み込み完了後に実行
    $(document).ready(function () {
      initializeSliders();
    });

    $(function () {
      $('.g-slider').not('.slick-initialized').slick({
        autoplay: true, //自動でスクロール
        autoplaySpeed: 0, //自動再生のスライド切り替えまでの時間を設定
        speed: 5000, //スライドが流れる速度を設定
        cssEase: 'linear', //スライドの流れ方を等速に設定
        slidesToShow: 7, //表示するスライドの数
        swipe: false, // 操作による切り替えはさせない
        arrows: false, //矢印非表示
        pauseOnFocus: false, //スライダーをフォーカスした時にスライドを停止させるか
        pauseOnHover: false, //スライダーにマウスホバーした時にスライドを停止させるか
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 4, //画面幅750px以下でスライド3枚表示
            },
          },
        ],
      });
    });
  });

  // -------------------------------------------------
  // お客様の声
  // -------------------------------------------------

  // $("document").ready(function () {

  //   $('#VoiceSlider').on('init', function (event, slick) {
  //     // console.log('slickスライダーにつけているクラス名 init');
  //     AOS.init(); // ここにAOSの命令やプログラムを書く
  //   });

  $('#VoiceSlider').not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '25%',
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 8000,
    infinite: true,
    pauseOnFocus: false, //フォーカスで一時停止
    pauseOnHover: false, //マウスホバーで一時停止
    pauseOnDotsHover: false, //ドットナビをマウスホバーで一時停止
    prevArrow: '<i class="fal fa-chevron-left prev-arrow"></i>',
    nextArrow: '<i class="fal fa-chevron-right next-arrow"></i>',
    // asNavFor: "#thumbnail-list", // サムネイルと同期

    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '10%',
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          adaptiveHeight: true,
          centerPadding: '0%',
        },
      },
    ],
  });

  // });

  // -------------------------------------------------
  // QA
  // -------------------------------------------------
  $(function () {
    $('.Qa dt').click(function () {
      $(this).find('span').toggleClass('active');
      $(this).next().slideToggle(300);
    });
  });

  // 電話番号の結合処理
  document.addEventListener('DOMContentLoaded', function () {
    const phone1 = document.getElementById('phone1');
    const phone2 = document.getElementById('phone2');
    const phone3 = document.getElementById('phone3');
    const phoneCombined = document.getElementById('phone_combined');

    // 入力値を結合する関数
    function combinePhoneNumbers() {
      const combined = `${phone1.value}-${phone2.value}-${phone3.value}`;
      phoneCombined.value = combined.replace(/-+$/, ''); // 末尾のハイフンを削除
    }

    // 各入力フィールドの監視
    [phone1, phone2, phone3].forEach((input) => {
      // 数字のみ入力可能にする
      input.addEventListener('input', function (e) {
        this.value = this.value.replace(/[^\d]/g, '');
        combinePhoneNumbers();

        // 最大文字数に達したら次のフィールドにフォーカス
        if (this.value.length >= this.maxLength) {
          const next = this.nextElementSibling;
          if (next && next.tagName === 'INPUT') {
            next.focus();
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /*
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
  */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    


/*
   class StickyHeader extends HTMLElement {
   constructor() {
   super();
   }

   connectedCallback() {
   this.header = document.getElementById('shopify-section-header');
   this.headerBounds = {};
   this.currentScrollTop = 0;
   this.preventReveal = false;
   this.predictiveSearch = this.querySelector('predictive-search');

   this.onScrollHandler = this.onScroll.bind(this);
   this.hideHeaderOnScrollUp = () => this.preventReveal = true;

   this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
   window.addEventListener('scroll', this.onScrollHandler, false);

   this.createObserver();
   }

   disconnectedCallback() {
   this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
   window.removeEventListener('scroll', this.onScrollHandler);
   }

   createObserver() {
   let observer = new IntersectionObserver((entries, observer) => {
   this.headerBounds = entries[0].intersectionRect;
   observer.disconnect();
   });

   observer.observe(this.header);
   }

   onScroll() {
   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

   if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

   if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
   if (this.preventHide) return;
   requestAnimationFrame(this.hide.bind(this));
   } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
   if (!this.preventReveal) {
   requestAnimationFrame(this.reveal.bind(this));
   } else {
   window.clearTimeout(this.isScrolling);

   this.isScrolling = setTimeout(() => {
   this.preventReveal = false;
   }, 66);

   requestAnimationFrame(this.hide.bind(this));
   }
   } else if (scrollTop <= this.headerBounds.top) {
   requestAnimationFrame(this.reset.bind(this));
   }

   this.currentScrollTop = scrollTop;
   }

   hide() {
   this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
   this.closeMenuDisclosure();
   this.closeSearchModal();
   }

   reveal() {
   this.header.classList.add('shopify-section-header-sticky', 'animate');
   this.header.classList.remove('shopify-section-header-hidden');
   }

   reset() {
   this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
   }

   closeMenuDisclosure() {
   this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
   this.disclosures.forEach(disclosure => disclosure.close());
   }

   closeSearchModal() {
   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
   this.searchModal.close(false);
   }
   }

   customElements.define('sticky-header', StickyHeader);
*/
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-business-lp"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) {
      return;
    }

    const initSlider = function (selector, options) {
      const slider = document.querySelector(selector);

      if (!slider) {
        return;
      }

      const $slider = window.jQuery(slider);

      if ($slider.hasClass('slick-initialized')) {
        return;
      }

      $slider.slick(options);
    };

    initSlider('.js-sauna-lp-fv-slider', {
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 1200,
      fade: true,
      cssEase: 'linear',
      arrows: false,
      dots: false,
      infinite: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      swipe: false,
      draggable: false,
      accessibility: false,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
$(function(){
  $('.search-filter-close').click(function(){
    $('body').removeClass('boost-pfs-filter-tree-open-body');
  });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-order-made-lp"]) return;
  try {
    
  $('document').ready(function () {
    // スライダー初期化を関数化
    function initializeSliders() {
      if ($('.g-slider').length) {
        $('.g-slider').on('init', function (event, slick) {
          AOS.init();
        });

        $('.g-slider').not('.slick-initialized').slick({
          autoplay: true,
          autoplaySpeed: 0,
          speed: 5000,
          cssEase: 'linear',
          slidesToShow: 7,
          swipe: false,
          arrows: false,
          pauseOnFocus: false,
          pauseOnHover: false,
          responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 4,
              },
            },
          ],
        });
      }
    }

    // DOMの読み込み完了後に実行
    $(document).ready(function () {
      initializeSliders();
    });

    $(function () {
      $('.g-slider').not('.slick-initialized').slick({
        autoplay: true, //自動でスクロール
        autoplaySpeed: 0, //自動再生のスライド切り替えまでの時間を設定
        speed: 5000, //スライドが流れる速度を設定
        cssEase: 'linear', //スライドの流れ方を等速に設定
        slidesToShow: 7, //表示するスライドの数
        swipe: false, // 操作による切り替えはさせない
        arrows: false, //矢印非表示
        pauseOnFocus: false, //スライダーをフォーカスした時にスライドを停止させるか
        pauseOnHover: false, //スライダーにマウスホバーした時にスライドを停止させるか
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 4, //画面幅750px以下でスライド3枚表示
            },
          },
        ],
      });
    });
  });

  $('#VoiceSlider').not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '25%',
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 8000,
    infinite: true,
    pauseOnFocus: false, //フォーカスで一時停止
    pauseOnHover: false, //マウスホバーで一時停止
    pauseOnDotsHover: false, //ドットナビをマウスホバーで一時停止
    prevArrow: '<i class="fal fa-chevron-left prev-arrow"></i>',
    nextArrow: '<i class="fal fa-chevron-right next-arrow"></i>',
    // asNavFor: "#thumbnail-list", // サムネイルと同期

    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '10%',
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          adaptiveHeight: true,
          centerPadding: '0%',
        },
      },
    ],
  });

  // });

  // -------------------------------------------------
  // QA
  // -------------------------------------------------
  $(function () {
    $('.Qa dt').click(function () {
      $(this).find('span').toggleClass('active');
      $(this).next().slideToggle(300);
    });
  });

  $(function () {
    // 初期状態では非表示
    $('#btm-btn').hide();
    
    // スクロール開始位置を保存する変数
    let isVisible = false;
    
    $(window).scroll(function() {
      fadeIn();
    });

    function fadeIn() {
      // スクロール位置が一定以上になったら表示
      let scroll = $(window).scrollTop();
      let windowHeight = $(window).height();
      
      // 画面の高さの半分以上スクロールしたら表示
      if(scroll > windowHeight / 2) {
        if (!isVisible) {
          $('#btm-btn').fadeIn(1000);
          isVisible = true;
        }
      } else {
        if (isVisible) {
          $('#btm-btn').fadeOut(1000);
          isVisible = false;
        }
      }
    }
    
    // ページ読み込み時に一度実行
    fadeIn();
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-order-made-lp02"]) return;
  try {
    
  $('document').ready(function () {
    // スライダー初期化を関数化
    function initializeSliders() {
      if ($('.g-slider').length) {
        $('.g-slider').on('init', function (event, slick) {
          AOS.init();
        });

        $('.g-slider').not('.slick-initialized').slick({
          autoplay: true,
          autoplaySpeed: 0,
          speed: 5000,
          cssEase: 'linear',
          slidesToShow: 7,
          swipe: false,
          arrows: false,
          pauseOnFocus: false,
          pauseOnHover: false,
          responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 4,
              },
            },
          ],
        });
      }
    }

    // DOMの読み込み完了後に実行
    $(document).ready(function () {
      initializeSliders();
    });

    $(function () {
      $('.g-slider').not('.slick-initialized').slick({
        autoplay: true, //自動でスクロール
        autoplaySpeed: 0, //自動再生のスライド切り替えまでの時間を設定
        speed: 5000, //スライドが流れる速度を設定
        cssEase: 'linear', //スライドの流れ方を等速に設定
        slidesToShow: 7, //表示するスライドの数
        swipe: false, // 操作による切り替えはさせない
        arrows: false, //矢印非表示
        pauseOnFocus: false, //スライダーをフォーカスした時にスライドを停止させるか
        pauseOnHover: false, //スライダーにマウスホバーした時にスライドを停止させるか
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 4, //画面幅750px以下でスライド3枚表示
            },
          },
        ],
      });
    });
  });

  $('#VoiceSlider').not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '25%',
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 8000,
    infinite: true,
    pauseOnFocus: false, //フォーカスで一時停止
    pauseOnHover: false, //マウスホバーで一時停止
    pauseOnDotsHover: false, //ドットナビをマウスホバーで一時停止
    prevArrow: '<i class="fal fa-chevron-left prev-arrow"></i>',
    nextArrow: '<i class="fal fa-chevron-right next-arrow"></i>',
    // asNavFor: "#thumbnail-list", // サムネイルと同期

    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '10%',
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          adaptiveHeight: true,
          centerPadding: '0%',
        },
      },
    ],
  });

  // });

  // -------------------------------------------------
  // QA
  // -------------------------------------------------
  $(function () {
    $('.Qa dt').click(function () {
      $(this).find('span').toggleClass('active');
      $(this).next().slideToggle(300);
    });
  });

  $(function () {
    // 初期状態では非表示
    $('#btm-btn').hide();
    
    // スクロール開始位置を保存する変数
    let isVisible = false;
    
    $(window).scroll(function() {
      fadeIn();
    });

    function fadeIn() {
      // スクロール位置が一定以上になったら表示
      let scroll = $(window).scrollTop();
      let windowHeight = $(window).height();
      
      // 画面の高さの半分以上スクロールしたら表示
      if(scroll > windowHeight / 2) {
        if (!isVisible) {
          $('#btm-btn').fadeIn(1000);
          isVisible = true;
        }
      } else {
        if (isVisible) {
          $('#btm-btn').fadeOut(1000);
          isVisible = false;
        }
      }
    }
    
    // ページ読み込み時に一度実行
    fadeIn();
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-order-made-seo"]) return;
  try {
    
  $('document').ready(function () {
    // スライダー初期化を関数化
    function initializeSliders() {
      if ($('.g-slider').length) {
        $('.g-slider').on('init', function (event, slick) {
          AOS.init();
        });

        $('.g-slider').not('.slick-initialized').slick({
          autoplay: true,
          autoplaySpeed: 0,
          speed: 5000,
          cssEase: 'linear',
          slidesToShow: 7,
          swipe: false,
          arrows: false,
          pauseOnFocus: false,
          pauseOnHover: false,
          responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 4,
              },
            },
          ],
        });
      }
    }

    // DOMの読み込み完了後に実行
    $(document).ready(function () {
      initializeSliders();
    });

    $(function () {
      $('.g-slider').not('.slick-initialized').slick({
        autoplay: true, //自動でスクロール
        autoplaySpeed: 0, //自動再生のスライド切り替えまでの時間を設定
        speed: 5000, //スライドが流れる速度を設定
        cssEase: 'linear', //スライドの流れ方を等速に設定
        slidesToShow: 7, //表示するスライドの数
        swipe: false, // 操作による切り替えはさせない
        arrows: false, //矢印非表示
        pauseOnFocus: false, //スライダーをフォーカスした時にスライドを停止させるか
        pauseOnHover: false, //スライダーにマウスホバーした時にスライドを停止させるか
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 4, //画面幅750px以下でスライド3枚表示
            },
          },
        ],
      });
    });
  });

  $('#VoiceSlider').not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '25%',
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 8000,
    infinite: true,
    pauseOnFocus: false, //フォーカスで一時停止
    pauseOnHover: false, //マウスホバーで一時停止
    pauseOnDotsHover: false, //ドットナビをマウスホバーで一時停止
    prevArrow: '<i class="fal fa-chevron-left prev-arrow"></i>',
    nextArrow: '<i class="fal fa-chevron-right next-arrow"></i>',
    // asNavFor: "#thumbnail-list", // サムネイルと同期

    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '10%',
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          adaptiveHeight: true,
          centerPadding: '0%',
        },
      },
    ],
  });

  // });

  // -------------------------------------------------
  // QA
  // -------------------------------------------------
  $(function () {
    $('.Qa dt').click(function () {
      $(this).find('span').toggleClass('active');
      $(this).next().slideToggle(300);
    });
  });

  $(function () {
    // 初期状態では非表示
    $('#btm-btn').hide();
    
    // スクロール開始位置を保存する変数
    let isVisible = false;
    
    $(window).scroll(function() {
      fadeIn();
    });

    function fadeIn() {
      // スクロール位置が一定以上になったら表示
      let scroll = $(window).scrollTop();
      let windowHeight = $(window).height();
      
      // 画面の高さの半分以上スクロールしたら表示
      if(scroll > windowHeight / 2) {
        if (!isVisible) {
          $('#btm-btn').fadeIn(1000);
          isVisible = true;
        }
      } else {
        if (isVisible) {
          $('#btm-btn').fadeOut(1000);
          isVisible = false;
        }
      }
    }
    
    // ページ読み込み時に一度実行
    fadeIn();
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-personal-lp"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) {
      return;
    }

    const initSlider = function (selector, options) {
      const slider = document.querySelector(selector);

      if (!slider) {
        return;
      }

      const $slider = window.jQuery(slider);

      if ($slider.hasClass('slick-initialized')) {
        return;
      }

      $slider.slick(options);
    };

    initSlider('.js-sauna-lp-fv-slider', {
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 1200,
      fade: true,
      cssEase: 'linear',
      arrows: false,
      dots: false,
      infinite: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      swipe: false,
      draggable: false,
      accessibility: false,
    });

    initSlider('.js-sauna-lp-case-slider', {
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 1200,
      fade: true,
      cssEase: 'linear',
      arrows: false,
      dots: false,
      infinite: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      swipe: false,
      draggable: false,
      accessibility: false,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
$(function(){
  $('.search-filter-close').click(function(){
    $('body').removeClass('boost-pfs-filter-tree-open-body');
  });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
$(function(){
  var baseTitle = window.mwApoInit.product.title;
  var basePrice = window.mwApoInit.product.variants[0].price / 100;
  var optionTable = [];

  productFunc();
  window.mwApoInit.onEvent = function (event, args) {
    if (event == "init::finish") {
      productFunc();
    }
  };

  function productFunc(){
    setTimeout(() => {
        // --------- オプション表を作る　ここから ---------
      console.log(mwApoInit.response);
        if (mwApoInit.response !== undefined) {
          for (val of Object.values(mwApoInit.response)) {
            for (i in val.values) {
              var optionname = '';
              for (j in val.options){
                if(val.options[j].id == val.values[i].option_id){
                  optionname = val.options[j].title;
                }
              }
              optionTable[i] = {
                'title': optionname,
                'value': val.values[i].value.title,
                'price': val.values[i].value.pricing.price
              };
            }
          }
          console.log(optionTable);
          $('.products-option .products-optionTtl').css('display', 'block');
        }
        // --------- オプション表を作る　ここまで ---------

        // --------- オプション選択時　ここから ---------
          var totalPrice = basePrice;
          var options = '';
          optionUpdate();
          $('.mw-option__control').change(function(){
            optionUpdate();
          });
          function optionUpdate(){
            totalPrice = basePrice;
            options = '';
            $('.mw-option__control').each(function(i,e){
              selected = $(e).val();
              if(selected){
                totalPrice += optionTable[selected].price;
                options += optionTable[selected].title +':'+ optionTable[selected].value + '／';
              }
            });
            if(options.slice(-1) == '／'){
              options = options.slice(0, -1);
            }
            $('.js-price').text('¥'+totalPrice.toLocaleString());
            $('#admin_price').val('¥'+totalPrice.toLocaleString());
            if(options == ''){
              $('.js-option').text('未選択');
              $('#admin_options').val('未選択');
            }else{
              $('.js-option').text(options);
              $('#admin_options').val(options);
            }
          }
        // --------- オプション選択時　ここまで ---------

        // --------- 内容をセッションストレージに保存　ここから ---------
        // console.log(baseTitle);
        // console.log(options);
        // $('.rfq-btn').click(function(){
        //   sessionStorage.setItem('rfqItem', baseTitle+'（'+options+'）');
        // });
        // var intervalId = setInterval(function(){
          // if($('#admin_options').length){
            // console.log(sessionStorage.getItem('rfqItem'));
            // $('#admin_options').val('TEST');
            // clearInterval(intervalId);
          // }else{
            // console.log('none');
          // }
        // },100);
        // --------- 内容をセッションストレージに保存　ここまで ---------

        $('.js-estimateOpen').click(function(){
          optionUpdate();
          $('#rfq_product_form').css('display', 'block');
          $('.js-estimateClose').css('display', 'block');
        });
        $('.js-estimateClose').click(function(){
          $('#rfq_product_form').css('display', 'none');
          $('.js-estimateClose').css('display', 'none');
        });

        // --------- theme_store_id チェック ここから ---------
        if (window.mwApoInit.theme_store_id !== null) {
          console.log(window.mwApoInit.theme_store_id);
        } else {
          console.error("theme_store_id is null");
        }
        // --------- theme_store_id チェック ここまで ---------

      }, 500);
  }

});

  } catch(e) { console.error(e); }
})();
})();
